'use client';

import { useEffect } from 'react';
import { parseUTMParams, saveUTMParams } from '@/lib/utils/utmTracking';

export default function SetUTMTracking() {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const searchParams = new URLSearchParams(window.location.search);
    const utmParams = parseUTMParams(searchParams);

    if (utmParams) {
      saveUTMParams(utmParams);
    }
  }, []);

  return null;
}
